/**
 * Cart Thresholds - Dynamic Update Script v3
 * Accordion with dynamic summary showing next goal
 *
 * assets/cart-thresholds.js
 */
(function() {
  'use strict';

  var SEL = {
    widget:    '[data-cart-thresholds]',
    barFill:   '[data-thresholds-bar-fill]',
    summary:   '[data-thresholds-summary]',
    goal:      '[data-threshold-goal]',
    check:     '[data-threshold-check]',
    status:    '[data-threshold-status]',
    marker:    '[data-threshold-marker]',
    cartTotal: '[data-cart-total]',
  };

  var CHECK_SVG = '<svg width="14" height="14" viewBox="0 0 20 20" fill="none"><path d="M16.6667 5L7.50001 14.1667L3.33334 10" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var DOT_HTML = '<span class="ct__goal-dot"></span>';
  var last = -1;

  function sub() {
    var el = document.querySelector(SEL.cartTotal);
    return el ? (parseInt(el.getAttribute('data-cart-total')) || 0) : 0;
  }

  function fmt(cents) {
    if (window.theme && typeof window.theme.formatMoney === 'function') {
      return window.theme.formatMoney(cents, window.theme.moneyFormat || '€{{amount_with_comma_separator}}');
    }
    return '€' + (cents / 100).toFixed(2).replace('.', ',');
  }

  function update() {
    var s = sub();
    if (s === last) return;
    last = s;

    var widgets = document.querySelectorAll(SEL.widget);
    if (!widgets.length) return;

    widgets.forEach(function(w) {
      var max = parseInt(w.getAttribute('data-cart-thresholds-max')) || 0;
      var total = parseInt(w.getAttribute('data-cart-thresholds-count')) || 0;
      if (!max) return;

      // Update bar
      var pct = Math.min((s / max) * 100, 100);
      var fill = w.querySelector(SEL.barFill);
      if (fill) fill.style.width = pct + '%';

      // Update goals and find next
      var rc = 0;
      var nextLabel = '';
      var nextRemaining = 0;
      var nextFound = false;

      // Sort goals by amount to find the correct "next" goal
      var goals = Array.from(w.querySelectorAll(SEL.goal));
      goals.sort(function(a, b) {
        return (parseInt(a.getAttribute('data-threshold-amount')) || 0) - (parseInt(b.getAttribute('data-threshold-amount')) || 0);
      });

      goals.forEach(function(g) {
        var amt = parseInt(g.getAttribute('data-threshold-amount')) || 0;
        var label = g.getAttribute('data-threshold-label') || '';
        var ok = s >= amt;
        var rem = Math.max(0, amt - s);

        if (ok) { g.classList.add('is-reached'); rc++; }
        else { g.classList.remove('is-reached'); }

        // Track next unreached goal
        if (!ok && !nextFound) {
          nextLabel = label;
          nextRemaining = rem;
          nextFound = true;
        }

        var ch = g.querySelector(SEL.check);
        if (ch) ch.innerHTML = ok ? CHECK_SVG : DOT_HTML;

        var st = g.querySelector(SEL.status);
        if (st) {
          st.innerHTML = ok
            ? '<span class="ct__goal-ok">✓</span>'
            : '<span class="ct__goal-remain">-' + fmt(rem) + '</span>';
        }
      });

      // Update markers
      w.querySelectorAll(SEL.marker).forEach(function(m) {
        var amt = parseInt(m.getAttribute('data-threshold-amount')) || 0;
        m.classList.toggle('is-reached', s >= amt);
      });

      // Update dynamic summary text
      var summary = w.querySelector(SEL.summary);
      if (summary) {
        if (rc === total && total > 0) {
          summary.textContent = '✓ Tutti gli obiettivi raggiunti!';
        } else if (nextFound) {
          summary.textContent = nextLabel + ' — manca ' + fmt(nextRemaining);
        } else {
          summary.textContent = 'Obiettivi: ' + rc + '/' + total;
        }
      }

      // Update done class
      w.classList.toggle('ct--done', rc === total && total > 0);
    });
  }

  function init() { last = -1; update(); setInterval(update, 500); bindMarkers(); }

  function bindMarkers() {
    document.addEventListener('click', function(e) {
      var marker = e.target.closest('[data-threshold-marker]');
      // Close all tooltips
      document.querySelectorAll('.ct__marker.is-active').forEach(function(m) {
        if (m !== marker) m.classList.remove('is-active');
      });
      // Toggle clicked marker
      if (marker) {
        marker.classList.toggle('is-active');
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else { init(); }

  document.addEventListener('shopify:section:load', function() { setTimeout(init, 100); });
})();